export { ReviewPage as default } from 'src/components/enpages/Ir/Financial/Review'
